import { CSSProperties } from 'react';

export interface IPlaceItem {
  name: string;
  region: string;
  type: number;
  uid: string;
}

export const BtnStyle: CSSProperties = {
  background: '#F2F4F7',
  color: '#55585C',
  fontSize: '.32rem',
  marginBottom: '.48rem',
};

export const ConfirmBtnStyle: CSSProperties = {
  background: ' #fdf3f4',
  color: '#E52E3D',
  fontSize: '0.32rem',
};
